import { FARAMASEP_ENDPOINT } from '../env';
import axios from 'axios';

export async function getDrugSearchResult(drug, zip) {
  const url = `${FARAMASEP_ENDPOINT}/drug-search`;

  const response = await axios.get(url, {
    params: {
      query: drug,
      location: zip,
    },
  });

  return response;
}

export async function getDrugInfoResult(drug, zip) {
  const url = `${FARAMASEP_ENDPOINT}/drug-info`;

  const response = await axios.get(url, {
    params: {
      name: drug,
      location: zip,
    },
  });

  return response;
}

export async function getDrugCompareResult(
  drug,
  zip,
  form = '',
  dosage = '',
  qty = ''
) {
  const url = `${FARAMASEP_ENDPOINT}/compare-price`;
  const regex = /[^a-zA-Z0-9 ]/g;

  const response = await axios.get(url, {
    params: {
      name: drug,
      location: zip,
      form: form,
      dosage: dosage.replace(regex, ''),
      quantity: qty,
    },
  });

  return response;
}
